export const GIRVI_THEME = {
  bgColor: "var(--theme-primary)",

  textColor: "#ffffff",

  bgGradient: "var(--theme-primary)",
  bgLight: "var(--theme-primary)",
  bgMedium: "var(--theme-primary)",

  // borderColor: "var(--theme-primary)",

  shadow: "0 4px 12px rgba(140, 29, 26, 0.3)",
};

export function formatGirviCurrency(amount) {
  const n = Number(amount);
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Number.isFinite(n) ? n : 0);
}

export function formatGirviWeight(weight) {
  const n = Number(weight);
  const safe = Number.isFinite(n) ? n : 0;
  return `${new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 3,
  }).format(safe)} g`;
}
